import { countReducer } from './counter-example/counter/counter.reducer';
import { errorHandlerReducer } from './shared/services/error-handling/error-handler.reducer';
import { createMetaReducer } from 'redux-gtm';
import { errorEventDefinitions } from './shared/services/error-handling/error-handler.gtm';
import { combineReducers } from '../../node_modules/@ngrx/store';

const analyticsMetaReducer = createMetaReducer(errorEventDefinitions);

export type CLPBPStore = {
  count: number;
  errorHandler: any;
};

const lightningStore = {
  count: countReducer,
  errorHandler: analyticsMetaReducer(errorHandlerReducer)
};

export function lightningReducer(state: any, action: any) {
  return combineReducers(lightningStore)(state, action);
}
